export const ACTION_TYPE = 'actionType';
export const DELAY_BETWEEN_LOOPS = 'delay';
export const MAX_NUMBER_OF_ITERATIONS = 'maxNumberOfIterations';